import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { AnioService } from '../../../../services/anio.service';
import { GrupoService } from '../../../../services/grupo.service';
import { DeclaracionService } from '../../../../services/declaracion.service';
import { Search } from '../../../../models/search';
import { DataTableDirective } from 'angular-datatables';

@Component({
  selector: 'app-sinfideicomiso',
  templateUrl: './sinfideicomiso.component.html',
  styleUrls: ['./sinfideicomiso.component.css']
})
export class SinfideicomisoComponent implements OnInit {
  public token;
  public message_success: string;
  public message_error: string;
  public status: string;
  public search: Search;
  public anios: any;
  public meses: any;
  public empresas: any;
  public loading = false;

  public dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<any> = new Subject();

  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;

  constructor(
    private _router: Router,
    private _anioService: AnioService,
    private _grupoService: GrupoService,
    private _declaracionService: DeclaracionService
  ) {
    this.token = this._grupoService.getToken();
    this.search = new Search(0, 0);
  }

  ngOnInit() {
    this.getAnios()
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10
    }
  }

  getAnios() {
    this.status = ''
    this.message_success = ''
    this.message_error = ''
    this._anioService.getAniosHabilitados(this.token).subscribe(
      response => {
        if (response.status == 'success') {
          this.anios = response.anios;
        }
      },
      error => {
        if (error['status'] == 401) {
          this._router.navigate(['logout/1']);
        } else {
          alert('Existen problemas al querer comunicarse con el servidor, intente más tarde')
        }
      }
    );
  }

  getMesesByAnio(anio_id) {
    this._anioService.getMesesByAnioActive(this.token, anio_id).subscribe(
      response => {
        if (response.status == 'success') {
          this.meses = response.meses;
        }
      },
      error => {
        if (error['status'] == 401) {
          this._router.navigate(['logout/1']);
        } else {
          alert('Existe problemas con el servidor, favor de intentar más tarde');
        }
      }
    );
  }

  searchEmpresas(){
    console.log(this.search)
    this._declaracionService.debtors(this.token, this.search).subscribe(
      response => {
        if (response.status == 'success') {
          this.empresas = response.empresas
          this.dtTrigger.next()
        }
      },
      error => {
        if (error['status'] == 401) {
          this._router.navigate(['logout/1']);
        } else {
          this.status = 'error';
          this.message_error = error.error.message

          setTimeout(function () {
            $(".message").fadeTo(500, 1).slideUp(500, function () {
              $(".message").hide();
            });
          }, 2000);
        }
      }
    );
  }

}
